export enum ReportQuestionnairesTableColumnTitle {
  Questionnaire = "Upitnik",
  Options = "",
}
